import React from 'react'
import { IonPage } from '@ionic/react'
import MedicalHistoryLookupContent from './MedicalHistoryLookupContent.component'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'

const MedicalHistoryLookup: React.FC = () => {
  return (
    <IonPage id='MedicalHistoryLookup'>
      <PCRHeader />

      <MedicalHistoryLookupContent />
    </IonPage>
  )
}

export default MedicalHistoryLookup
